import React from 'react';
import { Typography } from '@mui/material';
import { WidgetCard, WidgetEmptyState } from './WidgetCard';

const formatMetricValue = (value, format) => {
  if (value == null) return 'N/A';
  if (format === 'currency') {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
    }).format(value);
  }
  if (format === 'percent') {
    return new Intl.NumberFormat('en-US', {
      style: 'percent',
      maximumFractionDigits: 2,
    }).format(value);
  }
  if (format === 'number') {
    return new Intl.NumberFormat('en-US').format(value);
  }
  return value;
};

const MetricCardWidget = ({ widget, metric }) => {
  const format = widget?.params?.format;
  return (
    <WidgetCard
      title={widget.params?.title || 'Metric'}
      subtitle={widget.params?.metricId}
      testId={`report-widget-${widget.id || widget.params?.metricId || 'metric-card'}`}
    >
      <Typography variant="h4" sx={{ fontWeight: 700 }}>
        {formatMetricValue(metric?.value, format)}
      </Typography>
      {!metric && (
        <WidgetEmptyState message="Metric values appear after query execution." />
      )}
    </WidgetCard>
  );
};

export default MetricCardWidget;
